<script>
    export default {
        data() {
            return {}
        },
        methods: {
            trans_product(info) {
                let product_info = info.product_info
                let cr_info = info.cr_info
                let price_basic = product_info.skus[0].price / 100


                let re = {
                    tree: [{
                        k: '类型', // skuKeyName：规格类目名称
                        k_s: 's1', // skuKeyStr：sku 组合列表（下方 list）中当前类目对应的 key 值，value 值会是从属于当前类目的一个规格值 id
                        v: [],
                        largeImageMode: true, //  是否展示大图模式
                    }],
                    list: [],
                    price: price_basic, // 默认价格（单位元）
                    stock_num: product_info.sku_amount_all, // 商品总库存
                    collection_id: product_info.id, // 无规格商品 skuId 取 collection_id，否则取所选 sku 组合对应的 id
                }

                for (let sku of product_info.skus) {
                    let sku_info = {
                        id: sku.id, // skuId
                        s1: sku.id, // 规格类目 k_s 为 s1 的对应规格值 id
                        price: sku.price , // 价格（单位分）
                        stock_num: sku.amount // 当前 sku 组合对应的库存
                    }
                    let selector_info = {
                        id: sku.id, // skuValueId：规格值 id
                        name: sku.name, // skuValueName：规格值名称
                        imgUrl: sku.cover, // 规格类目图片，只有第一个规格类目可以定义图片
                        previewImgUrl: sku.preview, // 用于预览显示的规格类目图片
                    }
                    re.tree[0].v.push(selector_info)
                    re.list.push(sku_info)
                }
                let sku_info = {
                    goodsId: re.tree[0].v[0].id,
                    quota: cr_info.max_amount, //限购数
                    quotaUsed: product_info.already_buy, //已购买数量
                    sku: re,
                    goods: {
                        picture: product_info.skus[0].cover,
                        // 数据结构见下方文档
                    },

                }
                console.log(sku_info)
                return sku_info


            }
        }
    }

</script>
